import { useEffect, useState } from "react";
import { navLinks, siteName } from "@/mocks/homeData";

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#top"
            className={`flex items-center gap-2 cursor-pointer ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-lg text-lg ${
                solid ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
              }`}
            >
              <i className="ri-sparkling-2-fill" />
            </span>
            <span className="font-heading text-xl tracking-wide">{siteName}</span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-50/90 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#address"
              className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-links-line" />
              获取最新地址
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer ${
                solid ? "text-foreground-900" : "text-background-50"
              }`}
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-3 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#address"
              onClick={() => setMenuOpen(false)}
              className="mt-2 px-3 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center cursor-pointer"
            >
              获取最新地址
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}